<template>
  <div class="flex-box" style="background-color: var(--quyuan-red);">
    <div style="margin-bottom: 10vh;">
      <img
        src="../../../public/sticker/brakeUp.png"
        class="center-image special-center-image"
        alt="hduhelper"
      />

      <div>
        <span class="middle-font">{{ explainWords }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'

export default {
  name: 'failed',
  computed: {
    explainWords: function () {
      switch (store.state.HasError) {
        case 404:
          return '404啦'
        case 403:
          return '查询不到你的学籍信息'
        case 500:
          return '请稍后再试'
      }
      return '发生了一些错误...'
    },
  },
}
</script>

<style scoped>
.special-center-image {
  height: 35vh;
  bottom: 20vh;
  left: 10vw;
}

.flex-box {
  display: flex;
  z-index: 10;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-content: center;
}
</style>
